var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"lucide-icon",attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":_vm.color,"stroke-width":_vm.strokeWidth,"stroke-linecap":"round","stroke-linejoin":"round","aria-label":_vm.name}},_vm._l((_vm.paths),function(d,i){return _c('path',{key:i,attrs:{"d":d}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }